import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SUPPORTED_LANGS, DEFAULT_LANG, detectBrowserLang } from '../i18n/lang.config';

/**
 * langGuard
 * Valida el segmento :lang de la URL. Si es válido, activa ese idioma en
 * ngx-translate. Si NO es válido (p. ej. una URL antigua tipo /products),
 * redirige a la misma ruta bajo el idioma por defecto (/en/products),
 * preservando así los enlaces antiguos.
 */
export const langGuard: CanActivateFn = (route, state): boolean | UrlTree => {
  const translate = inject(TranslateService);
  const router = inject(Router);
  const lang = route.params['lang'];

  if (SUPPORTED_LANGS.indexOf(lang) !== -1) {
    if (translate.currentLang !== lang) {
      translate.use(lang);
    }
    return true;
  }

  // Segmento no válido: tratar toda la URL como ruta bajo el idioma por defecto.
  return router.parseUrl('/' + DEFAULT_LANG + state.url);
};

/**
 * rootRedirectGuard
 * Para la raíz ("/"): redirige al idioma del navegador (o al por defecto).
 */
export const rootRedirectGuard: CanActivateFn = (): UrlTree => {
  const router = inject(Router);
  return router.parseUrl('/' + detectBrowserLang());
};
